import AddMachineInfo from "../../../components/admin/addMachine/addMachineInfo";
import Footer from "../../../components/layout/footer";
import Header from "../../../components/layout/header";
import { useEffect } from "react";

const AddMachine = () => {
  return (
    <>
      <Header />
      <AddMachineInfo />
      <Footer />
    </>
  );
};
export default AddMachine;
